import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import ViewReplies from "./ViewReplies";
import "./ViewComplaint.css";
import ShowMoreText from "react-show-more-text";
import ComplaintReplyInModel from "../ComplaintReply/ComplaintReplyInModel";

class ViewComplaint extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            email: this.props.inquiryData.replyToEmail,
            subject: this.props.inquiryData.subject,
            inquiry: this.props.inquiryData.message,
            createdOn: this.props.inquiryData.createdDate,
            replies: this.props.inquiryData.complaintReplies,
            attachmentPaths: this.props.inquiryData.attachmentPaths,
            repliedByAdminName: "",
            repliedAdminId: "",
            reply: ""

        };

        this.handleShow = this.handleShow.bind(this);
        this.handleCloseViewReply = this.handleCloseViewReply.bind(this);
    }

    handleCloseViewReply = () => {
        this.setState({
            show: false,
        }, ()=>{this.props.getFilteredComplaints()});
    };

    handleShow = () => {
        this.setState({
            show: true,
        });

    };


    render() {
        if(this.props.inquiryData.attachmentPaths!== null){
            this.fileLinks = this.props.inquiryData.attachmentPaths.map((item, key) => {
                let encodedFileName = encodeURIComponent(item);
                let lastIndex = item.lastIndexOf("-");
                let name = item.substring(lastIndex+1);
                return (<div>
                    <p>
                        <span className="glyphicon glyphicon-download">
                        <a href={RESOURCE_BASE_URL + 'api/quality-complaint/attachments/download?p=' + encodedFileName}>{name}</a>
                        </span>
                    </p>
                </div>)
            }
            );
        }else {
            this.fileLinks = <span className="font-small"><small>添付されたファイルはありません</small></span>;
        }
        return (
            <span>
                <a className="btn btn-xs btn-success" onClick={this.handleShow}>
                     <FormattedMessage id="app.admin-inquiry-row.view"
                                       defaultMessage="View"
                                       description=""/>

                </a>

                <Modal show={this.state.show} onHide={this.handleCloseViewReply} dialogClassName="view-inquiry-modal">
                    <form onSubmit={this.onSubmit}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                <FormattedMessage id="app.admin-complaint-view.title"
                                                  defaultMessage="View Complaint"
                                                  description=""/>

                            </div>
                        </Modal.Header>
                        <Modal.Body>
                             <div className="row qc-line-height">
                                 <div className="">
                                     <div className="col-md-3 ">
                                        <b><FormattedMessage id="app.admin-complaint-view.date"
                                                          defaultMessage="Complaint Date"
                                                          description=""/></b>
                                    </div>
                                    <div className="col-md-9 ">
                                        {this.state.createdOn.substring(0, 4)} 年 {this.state.createdOn.substring(5, 7)} 月
                                        {this.state.createdOn.substring(8, 10)} 日&nbsp;&nbsp;{this.state.createdOn.substring(11, 16)}
                                    </div>
                                    </div>
                            </div>


                             <div className="row qc-line-height">
                                 <div className="">
                                     <div className="col-md-3 ">
                                        <b><FormattedMessage id="app.admin-inquiry-view.email"
                                                         defaultMessage="Email"
                                                             description=""/></b>
                                    </div>
                                    <div className="col-md-9 ">
                                        {/*<input type="text"
                                               className="form-control input-sm"
                                               name="subject"
                                               disabled={true}
                                               value={this.state.email}
                                        />*/}
                                        {this.state.email}
                                    </div>
                                    </div>
                            </div>
                            <div className="row qc-line-height">
                                 <div className="">
                                     <div className="col-md-3">
                                         <b><FormattedMessage id="app.admin-complaint-view.attachments"
                                                          defaultMessage="Attachments"
                                                              description=""/></b>
                                    </div>
                                    <div className="col-md-9">
                                        {this.fileLinks}
                                    </div>
                                    </div>
                            </div>
                            <div className="row qc-line-height">
                                 <div className="">
                                     <div className="col-md-3">
                                         <b>件名</b>
                                    </div>
                                    <div className="col-md-9">

                                        <FormattedMessage id="app.complaint-subject-manufacture"
                                                          defaultMessage="製造上の問題"
                                                             description=""/>
                                    </div>
                                    </div>
                            </div>
                        <div className="row qc-line-height">
                            <div className="">
                                <div className="col-md-3">
                                    <b><FormattedMessage id="app.quality-com-form.complaint"
                                                      defaultMessage="Complaint content"
                                                         description=""/></b>
                                </div>
                                <div className="col-md-9">

                                    <ShowMoreText
                                        lines={3}
                                        more='...詳細'
                                        less='...閉じる'
                                        anchorClass=''
                                    >
                                    {this.state.inquiry}
                                    </ShowMoreText>
                                </div>
                            </div>
                        </div>
                            <hr/>
                            <div className="row ">
                            <div className="">
                                <div className="col-md-5">
                                    <div className="">
                                        <h4>
                                            <FormattedMessage id="app.user-profile.user-profile.side-bar.complaints"
                                                              defaultMessage="Replies"
                                                              description=""/>

                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                            <div className="row"></div>
                            {this.state.replies.length === 0 &&
                            <div className="color-text text-align-center">
                                {/*<img className="no-reply-img" alt=""
                                     src={noRecords}/>*/}
                                {/*<h4>no replies to show at the moment .Our admin team will reply you as soon as possible !</h4>*/}
                            </div>

                            }

                            {this.state.replies.map(replyData => {
                                return <ViewReplies replyData={replyData} inquiry={this.props.inquiryData}/>;

                            })}

                            <div className="">
                            <ComplaintReplyInModel
                                userData={this.props.userData}
                                authenticate={this.props.authenticate}
                                authenticated={this.props.authenticated}
                                userId={this.props.userId}
                                inquiry = {this.props.inquiryData}
                                handleCloseViewReply={this.handleCloseViewReply}
                                getFilteredComplaints={this.props.getFilteredComplaints}
                            />
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                        </Modal.Footer>
                    </form>
                </Modal>
            </span>
        )
    }

}

export default ViewComplaint;



// WEBPACK FOOTER //
// ./src/components/Admin/NewQualityComplaint/ViewComplaint/ViewComplaint.js